//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//local imports 
import { ProgramModel, ProjectModel } from '@app/catalog';

@Component({
  selector: 'assign-project-to-program',
  standalone: false,
  templateUrl: './assign-project-to-program.component.html',
  styleUrl: './assign-project-to-program.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignProjectToProgramComponent {
  onCancelAssignment = output();

  programs = input.required<ProgramModel[]>();
  assignedProjects = input.required<ProjectModel[]>();
  projects = input.required<ProjectModel[]>();



  public applyAssignment() {

  }
}
